// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("path", { fillRule: "evenodd", d: "M9.16699 6.5L7.41677 7.75016V6.25H5.66677V8H7.067L5.66667 9.00024V15H1.00033V1H9.16699V6.5ZM7.41677 5.08354H5.66677V3.33354H7.41677V5.08354ZM2.75 10.9165H4.5V9.16646H2.75V10.9165ZM4.5 8H2.75V6.25H4.5V8ZM2.75 5.08354H4.5V3.33354H2.75V5.08354Z", clipRule: "evenodd" }),
            React.createElement("path", { fillRule: "evenodd", d: "M15 15.0007V9.75065L10.9167 6.83398L6.83333 9.75065V15.0007H15ZM12.0832 12.6673H9.7499V10.334H12.0832V12.6673Z", clipRule: "evenodd" }))));
};
Icon.displayName = 'HybridJobs16x16';
export default Icon;
//# sourceMappingURL=HybridJobs16x16.js.map